import React, { useState, useEffect, useRef } from "react";
import Menu from "./Menu";
import Overlay from "../overlay";
import { connect,useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import NonDestopMyAccount from "./MyAccountMenu/NonDestopMyAccount";
import{Link} from "react-router-dom";
import {ScreenOriantation, ScreenType} from "../../../utils/detectScreen";
import {
    menuOverlay,
    setNotification,
    headerNavigation,
    setMyAccountInfo,
    setMobileMenuState
} from "../../actions/HeaderActions";
//import HeaderData from "./headerMockJsonData.json";
import { getDataFromAPI } from "../../../service";
import Loader from "../loader";
import Notification from "./Notification";
import { TeamSiteComponentDetailsCall } from "../../../service/TeamSiteService"
import FauxTypeAhead from "../Typeahead";
import store from "../../../store/store";
import SearchTray from "../Typeahead/SearchTray" ;
import axios from "axios";
const HeaderContainer = ({
    showOverlay, menuOverlayfunc, setHeaderNav,
    setNotificationFunc, headerNavArr, 
   setMyAccountFunc, setMenuState, deviceWidth,
   customerId, customerLocale, accessToken, pageContentDetails,
   alert, customerPointsBalance,scrollOffSetFlag, tradingbalance, memberShipType, arpMemeberType, showMobileOverlay}) => {
    let orientationType = ScreenOriantation();
    let deviceType =  ScreenType();
    const{REACT_APP_SERVICE_URL, REACT_APP_IMAGEURL, REACT_APP_MC_URL_FLAG} =window.weeksWebCloudConfig;
    /* const[orientationType, setOrientationType] = useState(ScreenOriantation());
    const[deviceType, setDeviceType] = useState(ScreenType()); */
    const [bookSubMenu, setBookSubMenu] = useState(false);
    const [dreamSubMenu, setDreamSubMenu] = useState(false);
    const [bookSubmenuArr, setBookSubmenuArr] = useState(null);
    const [bookSubmenuSecondViewArr, setBookSubmenuSecondViewArr] = useState(null);
    const [dreamSubmenuArr, setDreamSubmenuArr] = useState(null);
    const [mainNavArr, setMainNavArr] = useState(null);
    const [displayNotification, setDisplayNotification] = useState(sessionStorage.getItem("NOTIFICATION_FLAG")? false : true);
    const [displayMyAccount, setDisplayMyAccount] = useState(false);
    const [displaySearchTray, setDisplaySearchTray] = useState(false);
    const [arpBanner, setArpBannerData] = useState(null);
    const [searchRegionData, setSearchRegionData] = useState(null);
    const [logoInfo, setLogoInfo] = useState(null);
    const [ipadOrientation, setIpadOrientation] = useState(null);
    const [tradingPowerBlnc, setTradingPowerBlnc] = useState(0)
    const dispatch = useDispatch();
    //debugger;
    const [typeAheadSearchLabel, setTypeAheadSearchLabel] = useState(null);
    const headerRef = useRef();
    const [isHeaderHidden, setIsHeaderHidden] = useState(false);
    let custLanguageCode =customerLocale.split('_')[0].toUpperCase();
    
    const RegionURL = `${REACT_APP_SERVICE_URL}/rcio/utilities/refinements/region-hierarchy/details?brandName=rci&languageCode=${custLanguageCode}&searchType=ALL`
    let getWeeksDepUrl =`${REACT_APP_SERVICE_URL}/rcio/${customerId}/ownerships/deposits`;
    const custlocaleFormated=customerLocale.split('_')
    //let tradingPowerBlnc = 0;

    // Hide header on scroll down, show on scroll up (body class toggled in App.js)
    useEffect(() => {
        const handleNavHidden = () => {
            setIsHeaderHidden(document.body.classList.contains('header-hidden'));
        };
        const observer = new MutationObserver(handleNavHidden);
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (headerNavArr.length === 0) {
             // deposit controller call fix for INC1981401/PWE-1817 
        axios({url:"/weeks-account/dashboard-deposit?call=async", method:"GET",params:{ajax:true}});
       // message translations call
       getMessage();

        // end message transaltion call 

            if (pageContentDetails !== undefined) {
                pageContentDetails.page_Content.Page_Row.find(value => {
                    value.components.find(data => {
                        if (data.name === "C90-Header") {
                            let callParms={
                                customerId:customerId,
                                customerLocale:customerLocale,
                                TScompContentBody:data,
                                accessToken:accessToken,
                            }
                            TeamSiteComponentDetailsCall(callParms).then(res => {
                                if (res.status === 200) {
                                    setTypeAheadSearchLabel(res.data.StaticContent[1].DCR.Content.PostLogin.HeaderComponentInfo.TypeaheadSearch);
                                    dispatch({type:'MAIN_MENU_LINK_TEXT',payload:res.data.StaticContent[1].DCR.Content.PostLogin.HeaderComponentInfo.MainMenuText});
                                    //setMainMenuText(res.data.StaticContent[1].DCR.Content.PostLogin.HeaderComponentInfo.MainMenuText)
                                    setArpBannerData(res.data.DynamicContent.document.Content.MyAccountInfo);
                                    setNotificationFunc(res.data.StaticContent[0].DCR.Content.PostLoginContainer!==undefined ? res.data.StaticContent[0].DCR.Content.PostLoginContainer : []);
                                    setLogoInfo(res.data.DynamicContent.document.Content.LogoImageContainer);
                                    if(res.data.StaticContent[0].DCR.Content.PostLoginContainer!==undefined){
                                        if (res.data.StaticContent[0].DCR.Content.PostLoginContainer.Alert !== undefined && 
                                            res.data.StaticContent[0].DCR.Content.PostLoginContainer.Alert.length > 0) {
                                            //console.log(orientationType+"................."+deviceType +"...................");
                                            if(deviceType ==="sm")sessionStorage.setItem("NOTIFICATION_FLAG", true);
                                            sessionStorage.getItem("NOTIFICATION_FLAG") ? setMenuState("ALL") : setMenuState("NOTIFICATION");
                                            menuOverlayfunc(true);
                                        }
                                        else {
                                            setMenuState("ALL");
                                            setDisplayNotification(false);
                                            menuOverlayfunc(false);
                                            sessionStorage.setItem("NOTIFICATION_FLAG", true);
                                        }
                                    }
                                    else{
                                        // console.log("nodata");
                                        sessionStorage.setItem("NOTIFICATION_FLAG", true);
                                        setMenuState("ALL");
                                        setDisplayNotification(false);
                                        menuOverlayfunc(false);
                                    }          
                                    
                                    setHeaderNav(res.data.DynamicContent.document.Content.PrimaryNavigationLinks);
                                    setMyAccountFunc(res.data.StaticContent[1].DCR.Content.PostLogin.HeaderComponentInfo.MyAccount)
                                    setMainNavArr(res.data.DynamicContent.document.Content.PrimaryNavigationLinks);
                                    
                                }
                                sessionStorage.getItem("NOTIFICATION_FLAG") ? menuOverlayfunc(false):menuOverlayfunc(true);
                            })
                        }
                    })
                  

                });
            }
        }
        else if (headerNavArr.length > 0) {
            setBookMenuArr();
        }

        setMainNavArr(headerNavArr);
        //debugger;
         if(headerNavArr.length === 0 && customerPointsBalance === null){
             //debugger;
            getCustomerPointsBalance();
        
        }
        
    }, [headerNavArr, displayMyAccount]);

    const getMessage = async () =>{
        const NewMsgServiceUrl = `${REACT_APP_SERVICE_URL}/utilities/message-translations/retrieval?messageGroup=RCI_React_Favorites_Points&brandId=1&brand=RCI&locale=${customerLocale}&appType=rcio`;
        // const NewMsgServiceUrl = `${REACT_APP_SERVICE_URL}/utilities/message-translations/retrieval?messageGroup=RCI_React_Favorites_Points&brandId=1&brand=RCI&locale=${customerLocale}&ConsumerChannel=Web&MemberType=POINTS&OperatorId=WEB00USER`;
        const OldMsgServiceUrl = `${REACT_APP_SERVICE_URL}/rcio/message/get-message?messageGroup=RCI_React_Favorites_Points&brandId=1&brand=RCI&locale=${customerLocale}&ConsumerChannel=Web&MemberType=WEEKS&OperatorId=WEB00USER`;
        REACT_APP_MC_URL_FLAG ?
        getDataFromAPI(NewMsgServiceUrl, "GET", customerId).then(res => {
            if (res.status === 200) {
                if (res.data) {
                    // console.log("update_msg_Data", res.data);
                    dispatch({ type: 'update_msg_Data', data: res.data.data });
                }
            }
        })
        :
        getDataFromAPI(OldMsgServiceUrl, 'GET', customerId, '', accessToken, custlocaleFormated[0], customerLocale).then(res => {
                    if (res.status === 200) {
                        if (res.data) {
                            dispatch({ type: 'update_msg_Data', data: res.data.data });
                        }
                    }
                })
       }
    
    window.addEventListener('orientationchange', function(){
        
        if(window.orientation === 90 || window.orientation === -90 ){
            setIpadOrientation("landscape");
        } else{
            setIpadOrientation("portrait");
        }
       }, false); 
    const setBookMenuArr = () => {
        headerNavArr.map(data => {
            if (Object.keys(data)[0] === "LinksWithTravel") {
                setBookSubmenuArr(data.LinksWithTravel);
            }
            else if (Object.keys(data)[0] === "LinksWithoutTravel") {
                setBookSubmenuSecondViewArr(data.LinksWithoutTravel);
            }
            else if (Object.keys(data)[0] === "LinksWithActivities") {
                setDreamSubmenuArr(data.LinksWithActivities);
            }
        })
    }
    
    
    const windowClickMenuClose = () => {
        bookSubMenu && setBookSubMenu(false);
        dreamSubMenu && setDreamSubMenu(false);
        menuOverlayfunc(false);
        setDisplayNotification(false);
        setDisplayMyAccount(false);
        document.body.classList.remove("no-body-scroll");
        !sessionStorage.getItem("NOTIFICATION_FLAG") && sessionStorage.setItem("NOTIFICATION_FLAG", true);
    }
    const BookMenu = (event) => {
        sessionStorage.setItem("NOTIFICATION_FLAG", true);
        event.preventDefault();
        dreamSubMenu && DreamSubMenuFunc(event);
        if (!bookSubMenu) {
            setBookSubMenu(true);
          
            menuOverlayfunc(true);
            setDisplayNotification(false);
            setDisplayMyAccount(false);
            document.body.classList.add("no-body-scroll");
        } else {
            menuOverlayfunc(false);
            setBookSubMenu(false);
            document.body.classList.remove("no-body-scroll");
        }
    }
    const DreamSubMenuFunc = (event) => {
        sessionStorage.setItem("NOTIFICATION_FLAG", true);
        event.preventDefault();
        bookSubMenu && BookMenu(event);
        if (!dreamSubMenu) {
            setDreamSubMenu(true)
            menuOverlayfunc(true);
            setDisplayNotification(false);
            setDisplayMyAccount(false);
            document.body.classList.add("no-body-scroll");
        } else {
            setDreamSubMenu(false);
            menuOverlayfunc(false);
            document.body.classList.remove("no-body-scroll");
        }
    }

    const handleNotification = () => {
        //debugger;
        sessionStorage.setItem("NOTIFICATION_FLAG", true);
        if (displayNotification) {
            setDisplayNotification(false);
            menuOverlayfunc(false);
            setMenuState("ALL");
            setDisplayMyAccount(false);
            document.body.classList.remove("no-body-scroll");
        }
        else {
            setDisplayNotification(true);
            document.body.classList.add("no-body-scroll");
            menuOverlayfunc(true);
            setBookSubMenu(false);
            setDreamSubMenu(false);
            setDisplayMyAccount(false);
        }
    }
    const handleMyAccount = () => {
        if(customerPointsBalance === null){
            getCustomerPointsBalance();
            if (!displayMyAccount) {
                setDisplayMyAccount(true);
                menuOverlayfunc(true);
            }
            else {
                menuOverlayfunc(false);
                setDisplayMyAccount(false);
            }
        }
        else{
            if (!displayMyAccount) {
                setDisplayMyAccount(true);
                menuOverlayfunc(true);
                document.body.classList.add("no-body-scroll");
            }
            else {
                menuOverlayfunc(false);
                setDisplayMyAccount(false);
                document.body.classList.remove("no-body-scroll");
            }
        }
        setBookSubMenu(false);
        setDreamSubMenu(false);
        setDisplayNotification(false);
        setMenuState("ALL");
        sessionStorage.setItem("NOTIFICATION_FLAG", true);     
    }

    const getCustomerPointsBalance = () =>{
        let callParms={
            customerId:customerId,
            customerLocale:customerLocale,
            accessToken:accessToken,
        }
        getDataFromAPI(getWeeksDepUrl,"GET",customerId, callParms, accessToken).then(res=>{
      
            store.dispatch({type:'SET_WEEKS_DEPOSIT_BALANCE',payload:res.data}); 
        })
    }

    const getSearchRegionList = async () =>{
        await getDataFromAPI(RegionURL,"GET",customerId,"",accessToken).then(res=>setSearchRegionData(res.data)); 
    }

    const handleFauxSearch = (e) =>{
    
        if(!displaySearchTray) {
        
        setDisplaySearchTray(true);

      
        document.body.classList.add("no-body-scroll");
       }  
       else
       {
           //debugger;
        setDisplaySearchTray(false);
        document.body.classList.remove("no-body-scroll");
       } 
    }


    const headerContainerStructure = () => {
        //debugger;
        return(
            <>
                <div className="row m-lg-0">
                           <div className={`col-12 mt-md-0 d-md-flex`}>
                                <div data-testid="rci-logo"  className="rci-logo-container">
                                <Link to="/" tabIndex="0">
                                    <img src={REACT_APP_IMAGEURL+logoInfo.ImagePath} 
                                    className="rci-logo"
                                    alt={logoInfo.AltText} 
                                    aria-label = {logoInfo.AltText}
                                    />
                                </Link>
                            </div>
                            {
                                arpMemeberType === "Platinum" ?
                                <div className="platinum-type-ahead-btn-wrapper" >
                                    <FauxTypeAhead 
                                    handleFauxSearchfunc={handleFauxSearch}  
                                    typeAheadSearchLabelTxt = {typeAheadSearchLabel}
                                    />
                                </div>
                                :
                                <div className={memberShipType !== "VVIL" ? "type-ahead-btn-wrapper" : "non-standard-type-ahead-btn-wrapper"} >
                                    <FauxTypeAhead 
                                        handleFauxSearchfunc={handleFauxSearch}  
                                        typeAheadSearchLabelTxt = {typeAheadSearchLabel}
                                    />
                                </div>
                            }
                            
                             <SearchTray 
                                displaySearchTrayFlag={displaySearchTray} 
                                handleFauxSearchfunc={handleFauxSearch}
                                typeAheadSearchLabelTxt = {typeAheadSearchLabel}
                                $deviceWidth ={deviceWidth}
                                searchData={searchRegionData}
                            />
                            
                             <Menu
                                BookMenu={BookMenu}
                                DreamMenuFunc={DreamSubMenuFunc}
                                windowClickMenuCloseFunc={windowClickMenuClose}
                                deviceWidth={deviceWidth}
                                MenuArr={mainNavArr}
                                showBookSubMenu={bookSubMenu}
                                showDreamSubMenu={dreamSubMenu}
                                handleNotificationFunc={handleNotification}
                                handleMyAccountFunc={handleMyAccount}
                                arpBannerData = {arpBanner}
                                displayNotificationFlag = {displayNotification}
                                displayMyAccountFlag = {displayMyAccount}
                                $showSubMenu={bookSubMenu}
                                $subMenuArr={bookSubmenuArr}
                                $bookSubmenuSecondViewArr={bookSubmenuSecondViewArr}
                                $showDreamSubMenu={dreamSubMenu}
                                $dreamSubMenuArr={dreamSubmenuArr}

                            />  
                             </div>
                           
                            </div>
                 </> 
        )                          
    }


    if (bookSubmenuSecondViewArr !== null || bookSubmenuArr !== null || dreamSubmenuArr !== null)
        return (
            <>
            
                <nav ref={headerRef} data-testid="header-component" className={`${showMobileOverlay || displaySearchTray ? "main-nav position-fixed-main-nav" : "main-nav overflow-main-nav"} ${isHeaderHidden ? 'nav-hidden' : ''}`}>
                    <div className="nav-bar">
                        {headerContainerStructure()}
                    </div>
                        <div className={`${showOverlay && displayNotification? "d-none d-lg-block" :"d-none"}`}>
                            <Notification handleNotificationFunc={handleNotification}/>
                        </div>
                        {displayMyAccount &&
                            <NonDestopMyAccount deviceWidth={deviceWidth}
                            showNotification={displayMyAccount}
                            arpBannerData = {arpBanner}
                            
                        />}
                    {showOverlay && <Overlay />}
                </nav>
            </>
        )
    else return null ;
}

const mapStateToProps = (state) => {

    return {
        showOverlay: state.CommonReducer.showOverlay,
        showMobileOverlay: state.CommonReducer.showMobileOverlay,
        screenWidth: state.CommonReducer.screenWidth,
        headerNavArr: state.CommonReducer.headerNavigation,
        customerId: state.CommonReducer.customerId,
        customerLocale: state.CommonReducer.locale,
        accessToken: state.CommonReducer.accessToken,
        pageContentDetails: state.CommonReducer.pageContent,
        alert: state.CommonReducer.notification.Alert,
        customerPointsBalance: state.CommonReducer.pointsBalance,
        scrollOffSetFlag:state.CommonReducer.scrollOffSet,
        deviceWidth: state.CommonReducer.screenWidth,
        tradingbalance: state.CommonReducer.pointsBalance,
        memberShipType: state.CommonReducer.customerProfile.customSegments[0]!==undefined ? state.CommonReducer.customerProfile.customSegments[0].attributeSubGroup:"",
        arpMemeberType:state.CommonReducer.customerProfile.enrolledARPName
    }

}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    menuOverlayfunc: menuOverlay,
    setHeaderNav: headerNavigation,
    setNotificationFunc: setNotification,
    setMyAccountFunc: setMyAccountInfo,
    setMenuState: setMobileMenuState
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);